import { cx } from '@emotion/css';
import { useMediaQuery } from '@sortlist-frontend/design-system/legacy';
import { Trans } from '@sortlist-frontend/translation/ssr';
import { FC, useMemo } from 'react';

import { getCompanyLogos } from '_core/utils/company-logos';
import { clientCompaniesData, CompanyType } from '_data/index';

import * as S from './styles';

type Props = {
  invert?: boolean;
  className?: string;
  logos?: CompanyType[];
};

export const Companies: FC<Props> = (props) => {
  const { invert = true, className, logos: providedLogos } = props;
  const { media_legacy } = useMediaQuery();

  // Use provided logos or generate them once during SSR/initial render
  const logos = useMemo(() => providedLogos ?? getCompanyLogos(clientCompaniesData, 8), [providedLogos]);

  return (
    <S.LogosWrapper className={cx(className, 'mt-16 lg:mt-0')}>
      <div className="layout-row layout-align-center-center">
        <S.LogosInnerWrapper
          className={cx(
            { 'rounded-xl': media_legacy.gtSm },
            !invert ? 'bg-secondary-900' : 'border bg-secondary-200 border-secondary-200',
            'p-4 flex-sm-100 flex-sm-100 flex-gt-sm-none',
          )}>
          {invert ? (
            <p className="py-2 text-center text-secondary-700">
              <Trans i18nKey={'common:logos.title'}>
                Sortlist is trusted by <b>+100K businesses</b> worldwide
              </Trans>
            </p>
          ) : null}
          <div className="layout-row layout-align-center-stretch layout-wrap text-secondary-500">
            {logos.map((company: CompanyType) => (
              <div
                className="layout-row layout-align-center-center"
                key={company.id}
                style={{ minWidth: 112, minHeight: 64 }}>
                <S.Logo
                  className="m-4"
                  alt={company.name}
                  src={company.logoSrc as string}
                  width={80}
                  height={32}
                  key={company.id}
                  invert={invert ? 'true' : 'false'}
                  priority={false}
                  loading="eager"
                  sizes="80px"
                />
              </div>
            ))}
          </div>
        </S.LogosInnerWrapper>
      </div>
    </S.LogosWrapper>
  );
};
